interface Props {
  error: unknown;
  componentStack?: string;
  resetError?: () => void;
}

export function ErrorFallback({ error, resetError }: Props) {
  const message = error instanceof Error ? error.message : 'Unbekannter Fehler';
  return (
    <div className="min-h-dvh flex items-center justify-center px-4 py-12 bg-background">
      <div className="w-full max-w-md space-y-4 rounded-2xl border border-border bg-card p-8 text-center">
        <h1 className="text-xl font-semibold">Etwas ist schiefgelaufen.</h1>
        <p className="text-sm text-muted-foreground">
          Die Seite konnte nicht geladen werden.
        </p>
        <p className="text-xs text-muted-foreground italic">{message}</p>
        <button
          type="button"
          onClick={() => {
            resetError?.();
            window.location.reload();
          }}
          className="mt-2 inline-flex items-center justify-center rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground hover:bg-primary-hover"
        >
          Seite neu laden
        </button>
      </div>
    </div>
  );
}
